//Note: Important!!!
//import the class here, not the object
import {HttpService} from 'service/HttpService';

import {UserAction, DesignerAction} from 'AppAction';
import AppConstants from 'AppConstants';
import Dispatcher from 'service/Dispatcher';


const BASE_URL = AppConstants.BASE_API_URL+"/user";


class UserAPI extends HttpService {
	register(registerRequest, callback) {
		this.post("/register", registerRequest, response => {
			const message = response.data;
			Dispatcher.dispatchAnAlert(message);

			if(typeof callback === 'function')
				callback(true);
		}, error => {
			this.defaultErrorHandler(error);			
			callback(false, error);
		});
	}

	verifyAccount(token, callback) {
		this.post("/verify?token="+token, null, response => {
			const session = response.data;
			
			const bearerToken = session['bearer'];
			const user = session['user'];
			const expiresOn = session['expiresOn'];

			Dispatcher.dispatch({
				type: UserAction.LOGIN_SUCCESS,
				user: user,
				token: bearerToken,
				expiresOn: expiresOn
			});

			callback(true);
		}, error => {
			this.defaultErrorHandler(error);			
			callback(false);
		});
	}

	sendVerificationEmail(emailAddress, callback) {
		this.post("/sendVerificationEmail", emailAddress, response => {
			const message = response.data;
			Dispatcher.dispatchAnAlert(message);

			if(typeof callback === 'function')
				callback(true);
		}, error => {
			this.defaultErrorHandler(error);			
			callback(false, error);
		});
	}


	sendForgetPasswordEmail(emailAddress, callback) {
		this.post("/sendForgetPwdEmail", emailAddress, response => {
			const message = response.data;
			Dispatcher.dispatchAnAlert(message);

			if(typeof callback === 'function')
				callback(true);
		}, error => {
			this.defaultErrorHandler(error);			
			callback(false, error);
		});
	}

	changePassword(token, newPassword, callback) {
		const data = {token: token, password: btoa(newPassword)};

		this.post("/changePassword", data, response => {
			const message = response.data;
			Dispatcher.dispatchAnAlert(message);

			if(typeof callback === 'function')
				callback(true);
		}, error => {
			this.defaultErrorHandler(error);			
			callback(false, error);
		});
	}

    updateProfilePic(newImage) {
		let formData = new FormData();
		formData.append("newImageFile", newImage);
		
		let headers = this.getHeaders();
		headers['content-type'] = 'multipart/form-data';

        this.postFormData("/updateProfilePic", formData, response => {
			Dispatcher.dispatch({
				type: UserAction.PROFILE_PIC_UPDATE,
				profilePicture: response.data.profilePicture,
				user: response.data
			});

            Dispatcher.dispatchAnAlert("Profile Pic Updated Successfully.");
        });
	}

	addBanner(newImage) {
		let formData = new FormData();
		formData.append("newImageFile", newImage);

		let headers = this.getHeaders();
		headers['content-type'] = 'multipart/form-data';

        this.postFormData("/addBanner", formData, response => {
			Dispatcher.dispatch({
				type: UserAction.BANNER_UPDATE,
				bannerImages: response.data.bannerImages,
				user: response.data
			});

            Dispatcher.dispatchAnAlert("Banner added successfully.");
        });
	}

	removeBanner(bannerImgUrl) {
        this.delete("/removeBanner?imageUrl="+bannerImgUrl, response => {
			Dispatcher.dispatch({
				type: UserAction.BANNER_UPDATE,
				bannerImages: response.data.bannerImages,
				user: response.data
			});

            Dispatcher.dispatchAnAlert("Banner removed successfully.");
        });
	}

	getPopularArtists() {
		const url = "/artists/popular";
        
        super.get(url, response => {
            Dispatcher.dispatch({
				type: DesignerAction.LOAD_POPULAR_ARTISTS,
                artists: response.data,
            });
		});
	}

	getActiveArtists() {
		const url = "/artists/active";
        
        super.get(url, response => {
            Dispatcher.dispatch({
				type: DesignerAction.LOAD_ACTIVE_ARTISTS,
                artists: response.data,
            });
		});
	}


	getAllStores() {
		super.get("/stores/list?pageNumber=0&pageSize=100", response => {
			Dispatcher.dispatch({
				type: DesignerAction.LOAD_ALL_STORES,
				stores: response.data
			});
		});
	}

	getAllArtist(prefix) {
		super.get("/artists/list?prefix="+prefix, response => {
			Dispatcher.dispatch({
				type: DesignerAction.LOAD_ALL_ARTISTS,
				artists: response.data,
				prefix: prefix
			});
		});
	}

	getAllUsers(pageNumber, pageSize, userTypes, userStatus, callback) {
		this.get("/list?pageNumber="+pageNumber+"&pageSize="+pageSize+"&userTypes="+userTypes.join(",")+"&userStatus="+userStatus, 
			response => {
				const users = response.data;

				if(typeof callback === 'function')
					callback(users);
			}, error => {
				this.defaultErrorHandler(error);			
				callback(false, error);
			});
	}

	deactivateAccount(userId, onSuccess) {
		super.post("/"+userId+"/deactivate", null, response => {
			this.logout();
			Dispatcher.dispatchAnAlert("Account deactivatd successfully.");
			onSuccess();
		});
	}

	updateUserStatus(userId, newStatus, onSuccess) {
		super.post("/"+userId+"/updateStatus?newStatus="+newStatus, null, response => {
			Dispatcher.dispatchAnAlert("Account updated successfully.");
			onSuccess();
		});
	}
}

export default new UserAPI(BASE_URL);


// WEBPACK FOOTER //
// ./src/service/api/UserAPI.js